// extracted by mini-css-extract-plugin
export var containFit = "Image-module--contain-fit--95f26";
export var coverFit = "Image-module--cover-fit--a4b27";
export var image = "Image-module--image--f9fbf";